var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('q-toolbar',{staticClass:"q-px-md"},[_c('q-toolbar-title',{staticClass:"text-weight-medium"},[_vm._v(" Página Inicial ")]),_c('q-toggle',{attrs:{"label":_vm.$t('edit')},model:{value:(_vm.edit),callback:function ($$v) {_vm.edit=$$v},expression:"edit"}})],1),_c('dashboard-main',{attrs:{"editGrid":_vm.edit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }